import { Outlet, Link } from "react-router-dom";
import styles from "./Layout.module.css";
import NURA from "../../assets/NURA.svg";
import { Stack } from "@fluentui/react";
import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";

const Layout = () => {
    const appStateContext = useContext(AppStateContext)
    const ui = appStateContext?.state.frontendSettings?.ui;

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className={styles.headerInner}>
                    <Stack horizontal verticalAlign="center">
                        <img
                            src={ui?.logo ? ui.logo : NURA}
                            className={styles.headerIcon}
                            aria-hidden="true"
                        />
                        <Link to="/" className={styles.headerTitleContainer}>
                            <h1 className={styles.headerTitle}>{ui?.title}</h1>
                        </Link>
                    </Stack>
                </Stack>
            </header>
            <Outlet />
        </div>
    );
};

export default Layout;
